import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
var MARGINS = 5;
var LINE_WIDTH = 2;
var POSITION_TO_MARGIN = {
  before: 'left',
  after: 'right'
};
export default function VerticalDragLine(_ref) {
  var _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'before' : _ref$position;
  return React.createElement("div", {
    className: "position-absolute flexbox flexbox-align-center zindex-small flexbox-column",
    style: _defineProperty({
      lineHeight: 0,
      top: 0,
      bottom: MARGINS
    }, POSITION_TO_MARGIN[position], -MARGINS)
  }, React.createElement("div", {
    style: {
      width: LINE_WIDTH,
      flex: '1 1 auto',
      borderRadius: 2
    },
    className: "background-primary"
  }));
}